import { RouteObject } from "react-router-dom";
import {
  SYSTEM_CHECK_PATH,
  SystemCheckPage,
} from "@/modules/system-check/pages/system-check";

export const systemCheckRoutes: RouteObject[] = [
  {
    path: SYSTEM_CHECK_PATH,
    element: <SystemCheckPage />,
  },
];
